import { PromoteTabCategoryDropdown } from './promote-tab-category-dropdown'
export default PromoteTabCategoryDropdown
